import { apiClient } from '../../../app/api/apiClient';

export interface CustomerDTO {
  id: number;
  telegram_id: number;
  username: string;
  full_name: string;
  joined_at: string;
  orders_count: number;
  total_purchases: number;
  generated_commission: number;
}

interface CustomersResponse {
  customers: CustomerDTO[];
}

export async function fetchCustomers(
  limit = 20,
  offset = 0,
): Promise<CustomersResponse> {

  const response = await apiClient.get<CustomersResponse>(
    `/api/representative/customers?limit=${limit}&offset=${offset}`,
  );

  return response.data;
}
